import React, { Fragment } from 'react';
import RevenueShareReportView from './RevenueShareReportView';

// Thin route entry — the V3 shell lives inside the view.
const RevenueShareReport = () => (
    <Fragment>
        <RevenueShareReportView />
    </Fragment>
);

export default RevenueShareReport;
